import {CustomerProductRestDto} from "@/api/pharma-cpc-product-mgmt/models";
import {CustomerProductRestDtoModel} from "@/models/api/pharma-cpc-product-mgmt/CustomerProductRestDtoModel";

export class CustomerProductWithImageDetailRestDtoModel {
    main_image_url: string | undefined;
    product: CustomerProductRestDto;

    constructor(product: CustomerProductRestDto, main_image_url: string | undefined = undefined) {
        this.main_image_url = main_image_url;
        this.product = product;
    }

    static createWithDefaults(): CustomerProductWithImageDetailRestDtoModel {
        return new CustomerProductWithImageDetailRestDtoModel(CustomerProductRestDtoModel.createWithDefaults());
    }
}
